import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import Layout from '@/components/Layout';
import Sidebar from '@/components/Sidebar';
import {type AboutUs, getAboutUs} from '@/api/api';
import styles from '@/styles/global.module.css';
import contentStyles from '@/styles/ContentList.module.css';

export default function About() {
    const [aboutUs, setAboutUs] = useState<AboutUs | null>(null);
    const [loading, setLoading] = useState(true);

    // Define breadcrumbs for this page
    const breadcrumbs = [
        {title: '首页', link: '/'},
        {title: '关于我们', link: '/about'}
    ];

    useEffect(() => {
        const fetchAboutUs = async () => {
            try {
                setLoading(true);
                const response = await getAboutUs();
                if (response.data.code === 1) {
                    setAboutUs(response.data.data);
                }
            } catch (error) {
                console.error('Error fetching about us content:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchAboutUs();
    }, []);

    return (
        <Layout>
            <div className={styles.pageny}>
                <div className={styles.container}>
                    <div className={styles.lujing}>
                        您当前位置：
                        {breadcrumbs.map((item, index) => (
                            <React.Fragment key={index}>
                                <Link to={item.link}>{item.title}</Link>
                                {index < breadcrumbs.length - 1 ? ' >> ' : ''}
                            </React.Fragment>
                        ))}
                    </div>
                    <div className={styles.clearfix}></div>

                    <div className={styles.pageLeftRightContainer}>
                        <Sidebar mainCategory="关于我们"/>

                        <div className={styles.pageRight}>
                            <div className={contentStyles.nyNews}>
                                <div className={contentStyles.nynewsTitle}>
                                    <h1>关于我们</h1>
                                </div>

                                {/* Page Us Content */}
                                <div>
                                    {loading ? (
                                        <p>加载中...</p>
                                    ) : aboutUs ? (
                                        <div dangerouslySetInnerHTML={{__html: aboutUs.jsonStr}}></div>
                                    ) : (
                                        <>
                                            <h3>NATF标准化职业技能考试认证中心简介</h3>
                                            <p>NATF标准化职业技能考试认证中心是经国家相关部门批准成立的职业技能考试认证机构，致力于为各行业提供专业、权威的职业技能标准化考试和认证服务。</p>

                                            <h3>使命与愿景</h3>
                                            <p>我们的使命是推动职业教育标准化发展，提升劳动者职业技能水平，促进人才培养与产业需求的有效对接。</p>
                                            <p>我们的愿景是成为中国最具影响力的职业技能考试认证平台，为国家人才强国战略和产业升级提供有力支撑。</p>

                                            <h3>核心业务</h3>
                                            <ul>
                                                <li>职业技能标准研发与制定</li>
                                                <li>标准化职业技能考试与认证</li>
                                                <li>职业技能竞赛组织与评审</li>
                                                <li>职业技能培训体系建设与指导</li>
                                                <li>职业技能政策研究与咨询</li>
                                            </ul>

                                            <h3>权威认证</h3>
                                            <p>NATF证书获得了国内众多知名企业和高校的认可，持证人在就业和职业发展中具有明显优势。我们建立了严格的质量保障体系，确保认证的权威性和公信力。</p>

                                            <h3>服务网络</h3>
                                            <p>我们在全国建立了广泛的服务网络，与各省市职业教育机构、行业协会和企业保持紧密合作，为各类人才提供便捷的考试与认证服务。</p>

                                            <h3>合作伙伴</h3>
                                            <p>我们与国内外众多教育机构、行业协会和企业建立了战略合作关系，共同推动职业教育和技能培养的创新发展。</p>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div className={styles.clearfix}></div>
            </div>
        </Layout>
    );
}
